<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
    <em
      class="showDebugsub"
      v-if="showDebug"
      @click="showDebugsub = !showDebugsub"
    >×</em
    >
    <div class="test_div" v-if="showDebug" v-show="showDebugsub">
      <select @change="changehuanjing" v-model="configurl">
        <option v-for="(val, key) in configurlList" :key="key" :value="val">
          {{ val.desc }}
        </option>
      </select>
      <p>
        长连接状态：{{ ws && ws.readyState == 1 ? '长连接正常' : '长连接异常' }}
      </p>
      <p>
        <button @click="endws">关闭长连接</button>&nbsp;
        <button @click="startws">开启长连接</button>
      </p>
      <p>
        <button @click="endlx">关闭轮训</button>&nbsp;
        <button @click="startlx">开启轮训</button>
      </p>
      <p>
        <button @click="endsei">关闭sei</button>&nbsp;
        <button @click="startsei">开启sei</button>
      </p>
      <button @click="closeDebug">退出debug</button>
    </div>
    <img
      v-if="showexit && LIMI_ENV === 'electron'"
      @click="show1 = 1"
      src="../static/img/login/clear.png"
      class="exit cursor"
      alt
    />
    <alert
      v-if="alertIsShow && showWIndow"
      :show="alertIsShow && showWIndow"
      :sameOne="alertIsShow === 2 ? '网络不可用' : '该账号已在其他设备登录'"
      :sameTwo="alertIsShow === 2 ? '请检查网络设置' : ''"
      :cancal="alertIsShow === 2 ? '我知道了' : '确定'"
      @cancelEvent="alertCance"
    ></alert>
    <alert
      v-if="httpStatus && httpStatus != 3 && showWIndow"
      :show="httpStatus && httpStatus != 3 && showWIndow"
      :sameOne="httpStatus == 2 ? '网络慢，请稍后重试' : '服务异常，请稍后重试'"
      btn="重试"
      :cancal="
        httpData.code == 300203 || httpData.code == 300205 ? '退出' : '取消'
      "
      @ensure="httpEnsure"
      @cancelEvent="httpCancal"
    ></alert>
    <alert
      v-if="httpStatus == 3"
      :show="httpStatus == 3"
      sameOne="登录信息失效"
      errorNum="为保障您的账号安全,请重新登录"
      cancal="确定"
      @cancelEvent="tokenEnsure"
    ></alert>
    <alert
      v-if="show1"
      :sameTwo="alertText1"
      :cancal="show1 === 2 ? '确定' : '取消'"
      :btn="show1 === 2 ? '' : '确定'"
      :show="show1"
      @cancelEvent="cancel"
      @ensure="exitapp"
    ></alert>

    <Toast
      :showText="showText"
      v-if="showText"
      @toastCallBack="toastCallBack"
    />
    <Eyeshield v-if="openEye" :needToast="needToast" />
  </div>
</template>
<script>
import liSrv from 'liSrv';
import utils from 'utils';
import common from 'common';
import httpRequest from './js/httpUtils';
import alert from './components/basic/alert.vue';
import Eyeshield from './components/basic/eyeshield/eyeshield.vue';
import Toast from './components/basic/toast.vue';

import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import socket from '@/js/socket.js';
if (LIMI_ENV === 'electron') {
  var ipc = window.require('electron').ipcRenderer;
  var fs = window.require('fs');
  ipc.on('device_id', (e, device_id) => {
    common.set('pc_h5_device_id', device_id);
  });
}
import { createBLog } from '../src/js/log';
import { IFly } from 'limi-lib/dist/lib/limi/audio/IFly';
let ifly;
export default {
  provide() {
    return {
      pageReload: this.pageReload,
    };
  },
  name: 'App',
  data() {
    return {
      isRouterAlive: true,
      intervalData: {},
      magAckIntervalData: {}, //ack失败补发定时器
      zdclose: false, //长连接是否自动关闭
      alertIsShow: 0, //是否显示弹窗
      showText: '',
      showWIndow: true,
      showexit: false,
      show1: 0,
      alertText1: '确定退出吗？',
      ws: null,
      showDebug: common.get('showDebug'),
      openEye: false,
      needToast: true,
      showDebugsub: true,
      configurl: common.get('configurl') || common.configurl,
      configurlList: common.get('configurlList'),
      LIMI_ENV: LIMI_ENV,
      ack_unique_id: '',
      danmu_start_timestamp: '', //最后一条弹幕ctime
      wsReconnectionNum: 0, //长连接重连次数
      rtcStatus: 0, //是否可以语音连麦语音连麦
      eventConfig: 0,
    };
  },
  components: {
    alert,
    Toast,
    Eyeshield,
  },
  computed: {
    ...mapState([
      'lesson_id',
      'class_id',
      'userID',
      'teacher_id',
      'ping_recv_timeout',
      'ping_time',
      'COOK',
      'phone',
      'protocol_switch',
      'banned_speak',
      'httpStatus',
      'httpData',
      'seiTime',
      'online',
      'apiLessonInState',
      'wsLessonInState',
      'get_livemsg_addr_num',
      'send_socket_data_recall',
      'bzr_text_banned',
      'smallClassName',
      'smallClassId',
      'realname',
      'get_msg_time',
      'send_socket_times',
      'subject',
      'internal_users',
      'class_type',
      'lessonState',
      'fakeLive',
    ]),
    ...mapGetters(['isExperientialCourse']),
  },
  watch: {
    $route(to, from) {
      if (to.name != 'playback' || to.name != 'video') {
        this.openEye = false;
        // common.setSession("eyeMode", false);
      }
    },
    online(isOnLine) {
      if (!isOnLine) {
        this.showText = '网络不可用，请检查网络设置';
      }
    },
  },
  created() {
    this.getServerTime().then(({ res, ok }) => {
      if (!ok) return;
      let time = Math.floor(Date.now() / 1000);
      if (Math.abs(time - res.time) >= 180) {
        this.alertText1 =
          '电脑时间有误，可能会导致上课异常，请重新设置电脑时间';
        this.show1 = 2;
      }
    });
    if (LIMI_ENV === 'electron') {
      this.showDebug && ipc.send('openDevTools');
      let body = document.getElementsByTagName('body')[0];
      body.onkeydown = (event) => {
        if (event.keyCode == 27) {
          this.show1 = 1;
        }
      };
      if (!fs.existsSync(nodeProcess.cwd() + '/confing.json')) {
        fs.writeFileSync(
          //创建配置文件
          nodeProcess.cwd() + '/confing.json',
          JSON.stringify({}),
        );
      }
    } else {
      //
    }
    this.routeRedirect();
    this.updateState();
    this.eventHub();
    common.get('showDebug') && this.getHJ();
    //获取本地ip
    utils.getLANIP();
    window.addEventListener('online', () => {
      this.$root.eventHub.$emit('networkOnline', true);
      this.alertIsShow = 0;
    });
    window.addEventListener('offline', () => {
      this.$root.eventHub.$emit('networkOnline', false);
      if (this.$route.name === 'video') {
        this.alertIsShow = 2;
      } else {
        this.showText = '网络不可用，请检查网络设置';
      }
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventNoNetToast',
      });
    });
  },
  mounted() {
    this.mobRun();
    //前后台切换
    this.visibilityChange();
  },
  updated() {
    if (['password', 'class'].includes(this.$route.name)) {
      this.showexit = true;
    } else {
      this.showexit = false;
    }
  },
  methods: {
    ...mapMutations([
      'updateState',
      'resetState',
      'upDateServerTime',
      'upDateBannedSpeak',
      'upDateTextBannedSpeak',
      'httpErr',
      'refreshNet',
      'upDateApiLessonInState',
      'updateVoiceSoe',
      'upDateWsLessonInState',
      'saveNewVersion',
      'upDateLessonState',
      'upDateBzrTextBanned',
    ]),
    ...mapActions([
      'lessonOut',
      'lessonIn',
      'getMsgClient',
      'getServerTime',
      'getLatestVersion',
      'getAnswerRank',
      'getBadgeRank',
      'getPraiseInfo',
      'apiSendGift',
      'sendPkData',
      'durationRport',
      'recordLessonOut',
    ]),
    exitapp() {
      ipc.send('closedEv');
    },
    cancel() {
      this.alertText1 = '确定退出吗？';
      this.show1 = 0;
    },
    pageReload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    updateVersion(type) {
      //全局升级检测
      let data = {
        platform: common.device,
        version: common.version,
        uid: this.userID,
      };
      if (type) {
        data.from = type;
      }
      this.getLatestVersion(data).then(({ res, ok }) => {
        this.saveNewVersion(ok && res.update);
      });
    },
    endws() {
      this.zdclose = true;
      this.ws_close();
      this.ws = null;
    },
    startws() {
      if (!this.ws) {
        this.doWebSocket();
      }
    },
    endlx() {
      clearInterval(this.intervalData['getMsgClientInterval']);
      this.intervalData['getMsgClientInterval'] = null;
    },
    startlx() {
      clearInterval(this.intervalData['getMsgClientInterval']);
      this.intervalData['getMsgClientInterval'] = window.setInterval(() => {
        this.getMsgClientData();
      }, this.get_msg_time * 1000);
    },
    endsei() {
      this.$root.eventHub.$emit('test_use_sei', false);
    },
    startsei() {
      this.$root.eventHub.$emit('test_use_sei', true);
    },
    visibilityChange() {
      //判断页面是否激活
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          if (this.$route.name === 'video' && this.eventConfig === 0) {
            this.durationRport({
              time: common.getTemServerTime(),
              event: 2004,
              data: {
                class_id: this.class_id,
                lesson_id: this.lesson_id,
                student_id: this.userID,
              },
            });
          }
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventAppState',
            data: {
              action: 1,
            },
          });
        } else {
          //切后台
          if (this.$route.name === 'video' && this.eventConfig === 0) {
            this.durationRport({
              time: common.getTemServerTime(),
              event: 2003,
              data: {
                class_id: this.class_id,
                lesson_id: this.lesson_id,
                student_id: this.userID,
              },
            });
          }
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventAppState',
            data: {
              action: 0,
            },
          });
        }
      });
    },
    checkMicrophonePermission(type) {
      if (!ifly) ifly = new IFly();
      ifly.check().then(
        () => {
          this.$root.eventHub.$emit('checkMicrophonePermissionSuccess');
          //
        },
        (e) => {
          //因为360浏览器未返回code码，增加容错机制
          //code=8没有设备，其余没有权限
          let code =
            e.code ||
            (e.name === 'DevicesNotFoundError' || e.name === 'NotFoundError'
              ? 8
              : 0);
          //
          this.$root.eventHub.$emit('checkMicrophonePermissionError', code);
          //
        },
      );
    },
    toastCallBack() {
      this.showText = '';
      this.refreshNet(true);
    },
    getHJ() {
      liSrv.getEnvList((res, ok) => {
        if (!ok) return;
        common.set('configurlList', res);
        this.configurlList = res;
        let configurl = common.get('configurl');
        if (configurl && !JSON.stringify(res).includes(configurl.url)) {
          window.confirm('环境变更');
          common.remove('configurl');
          this.resetState();
          window.location.reload();
        }
      });
    },
    closeDebug() {
      common.remove('showDebug');
      common.remove('configurl');
      this.resetState();
      window.location.reload();
    },
    changehuanjing() {
      common.set('configurl', this.configurl);
      this.resetState();
      this.ws && this.ws.close();
      this.closeWsClearInterval();
      this.$router.replace('/');
    },
    tokenEnsure() {
      this.httpErr({
        type: 0,
        data: {},
      });
      this.resetState();
      this.ws_close();
      this.closeWsClearInterval();
      this.$router.replace('/login');
    },
    httpEnsure() {
      this.showWIndow = false;
      setTimeout(() => {
        httpRequest(this.httpData);
        this.httpErr({
          type: 0,
          data: {},
        });
        this.showWIndow = true;
      }, 800);
    },
    httpCancal() {
      this.showWIndow = false;
      this.$root.eventHub.$emit('httpCancal', this.httpData);
      setTimeout(() => {
        this.httpErr({
          type: 0,
          data: {},
        });
        this.showWIndow = true;
      }, 800);
    },
    alertCance() {
      this.showWIndow = false;
      setTimeout(() => {
        this.alertIsShow = 0;
        this.showWIndow = true;
      }, 800);
    },
    mobRun() {
      let minWidth = window.screen.availWidth;
      let zoom = minWidth / 1258;
      if (minWidth > 1258) {
        minWidth = 1258;
        zoom = 1;
      }
      document.getElementById('app').style.minWidth = minWidth + 'px';
      document.body.style.zoom = zoom;
    },
    routeRedirect() {
      let routename = this.$route.name;
      //没有请求到config接口
      if (
        (routename !== 'homepage' && !common.API) ||
        !common.getSession('ping_recv_timeout')
      ) {
        this.$router.replace({
          name: 'homepage',
          query: this.$route.query,
        });
        return;
      }
      /*如果是非登录页面，判断是否有用户id和cook，如果没有则跳转到登录页面(首页)*/
      if (
        routename !== 'homepage' &&
        routename !== 'login' &&
        routename !== 'password' &&
        routename !== 'passwordreset' &&
        common.getSession('COOK')
      ) {
        //
      } else {
        if (
          routename === 'login' ||
          routename === 'password' ||
          routename === 'passwordreset'
        )
          return;
        this.$router.replace({
          name: 'homepage',
          query: this.$route.query,
        });
      }
    },
    startGetMsgClient() {
      //4s一次请求数据
      if (!this.intervalData['getMsgClientInterval']) {
        this.intervalData['getMsgClientInterval'] = window.setInterval(() => {
          //长链接不可用或者长连接没有进课成功
          if (
            !this.ws ||
            this.ws.readyState !== 1 ||
            this.wsLessonInState !== 1
          ) {
            this.getMsgClientData();
          }
        }, this.get_msg_time * 1000);
      }
    },
    getMsgClientData() {
      //如果没有进课成功,重新进课
      if (this.apiLessonInState !== 1) {
        this.lessonInFn();
        return;
      }
      //api获取长连接数据函数
      this.getMsgClient({
        lesson_id: this.lesson_id,
        start_timestamp: this.danmu_start_timestamp,
      }).then(({ res, ok }) => {
        if (!ok) return;
        res.forEach((v, i) => {
          this.message({ data: v }, 'api');
        });
      });
    },
    doWebSocket() {
      if (this.$route.name !== 'video') return;
      this.upDateWsLessonInState(0);
      //长连接开始连接
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventSocketConnect',
        data: {
          url: common.getSession('websocket_wss_url'),
        },
      });
      socket.doWebSocket(this.open, this.message, this.close, (err) => {
        //长连接连接失败
        this.$root.eventHub.$emit('createLog', {
          id: 'LMTrackEventSocketFailure',
          data: {
            url: common.getSession('websocket_wss_url'),
            error: 'WebSocket error',
          },
        });
      });
    },
    open(event) {
      this.ws = event.target;
      //长连接连接日志
      // if (this.protocol_switch == 0) {
      //   this.auth();
      // }
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventSocketSuccess',
        data: {
          url: common.getSession('websocket_wss_url'),
        },
      });
    },
    //goIm发送鉴权消息
    auth() {
      var textEncoder = new TextEncoder('utf-8');
      var token = {
        mid: Number(this.phone),
        room_id: 'live://' + this.lesson_id,
        platform: 'web',
        accepts: [],
      };
      var headerBuf = new ArrayBuffer(16);
      var headerView = new DataView(headerBuf, 0);
      var bodyBuf = textEncoder.encode(JSON.stringify(token));
      headerView.setInt32(0, 16 + bodyBuf.byteLength);
      headerView.setInt16(4, 16);
      headerView.setInt16(6, 1);
      headerView.setInt32(8, 7);
      headerView.setInt32(12, 1);
      //
      this.ws.send(this.mergeArrayBuffer(headerBuf, bodyBuf));
    },
    sendImMessage(message) {
      let imConfig = {
        stu_rcv_pre_lesson: 1000,
        stu_answer_quick_question: 2000,
        stu_send_danmu_message: 3000,
        get_answer_rank: 4000,
        get_badge_rank: 5000,
        praise_by_answer: 7000,
        sendCoinGift: 8000,
        get_soe: 8003,
        msg_ack: 9001,
        stu_ack_ping: 9002,
      };
      var textEncoder = new TextEncoder('utf-8');
      var headerBuf = new ArrayBuffer(16);
      var headerView = new DataView(headerBuf, 0);
      var bodyBuf = textEncoder.encode(JSON.stringify(message));
      headerView.setInt32(0, 16 + bodyBuf.byteLength);
      headerView.setInt16(4, 16);
      headerView.setInt16(6, 1);
      headerView.setInt32(8, imConfig[message.type]);
      headerView.setInt32(12, 1);
      //
      this.ws.send(this.mergeArrayBuffer(headerBuf, bodyBuf));
    },
    //向goIm发送心跳包
    heartbeat() {
      var headerBuf = new ArrayBuffer(16);
      var headerView = new DataView(headerBuf, 0);
      headerView.setInt32(0, 16);
      headerView.setInt16(4, 16);
      headerView.setInt16(6, 2);
      headerView.setInt32(8, 2);
      headerView.setInt32(12, 1);
      //
      this.ws.send(headerBuf);
    },
    //goIm合并消息包
    mergeArrayBuffer(ab1, ab2) {
      var u81 = new Uint8Array(ab1),
        u82 = new Uint8Array(ab2),
        res = new Uint8Array(ab1.byteLength + ab2.byteLength);
      res.set(u81, 0);
      res.set(u82, ab1.byteLength);
      //
      return res.buffer;
    },
    //收到发题命令，触发发题
    sendQusestion(datas, type) {

      const unique_id =
        datas.unique_id || (datas.data.qa && datas.data.qa.uuid);
      if (utils.messageFilter(unique_id, 'displayList')) {
        //
        if (type == 'sei') {
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventReceiveQuestion',
            data: {
              unique_id,
              question_id: datas.data.quick_question_id,
              reffer: type,
            },
          });
        }
        if (datas.data.type == 5) {
          let filterList = common.get('filterList') || [];
          filterList.push(unique_id);
          common.set('filterList', filterList);
        }
        let obj = common.getSession('questionList') || {};
        if (obj.canUse || type == 'sei') {

          this.$root.eventHub.$emit('question', datas, type);
          if (Object.keys(obj).length != 0) {
            obj.canUse = false;
            common.setSession('questionList', obj);
          }
        }
      }
    },
    /* <<<<<<<<<<<<<<  ✨ Windsurf Command ⭐ >>>>>>>>>>>>>>>> */
    /**
     * @description: 发送投币命令
     * @param {object} datas 投币数据
     * @param {string} type 来源 sei或者api
     * @return:
     */
    /* <<<<<<<<<<  072116ee-f19e-41b7-96d3-087728192376  >>>>>>>>>>> */
    sendCoin(datas, type) {
      if (utils.messageFilter(datas.unique_id, 'displayList')) {
        //
        this.$root.eventHub.$emit('coin', datas);
        let obj = common.getSession('coinList') || {};
        if (obj[datas.unique_id]) {
          obj[datas.unique_id].canUse = false;
        }
        Reflect.deleteProperty(obj, datas.unique_id);
        common.setSession('coinList', obj);
      }
    },
    getAnswerRanking(data) {
      this.getAnswerRank({
        lessonId: data.lesson_id,
        smallClassId: data.smallClassId,
      }).then(({ res, ok }) => {
        if (!ok) return;
        this.message({ data: res }, 'api');
      });
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventSendRankReq',
        data: {
          type: 'question_rank',
          channel: 'rank_api', //"rank_api",socket
          rev_unique_id: data.rev_unique_id,
        },
      });
    },
    getBadgeRanking(data) {
      this.getBadgeRank({
        batchId: data.batchId,
        smallClassId: data.smallClassId,
        lessonId: data.lesson_id,
      }).then(({ res, ok }) => {
        if (!ok) return;
        this.message({ data: res }, 'api');
      });
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventSendRankReq',
        data: {
          type: 'badge_rank',
          channel: 'rank_api', //"rank_api",socket
          rev_unique_id: data.rev_unique_id,
        },
      });
    },
    getPraiseData(data) {
      this.getPraiseInfo(data).then(({ res, ok }) => {
        if (!ok) return;
        this.message({ data: res }, 'api');
      });
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventBatchPraiseReq',
        data: {
          channel: 'praise_api',
          unique_id: data.request_id,
        },
      });
    },
    //评价补发
    commitComment(datas) {
      liSrv.commitComment(
        {
          mark: datas.data.mark, // 星级1-5
          comment: datas.data.comment,
          classId: this.class_id,
          lessonId: this.lesson_id,
          teacherId: this.teacher_id,
          recvUniqueId: datas.data.recv_unique_id,
          uniqueId: datas.unique_id,
        },
        (res, ok) => {
          if (ok) {
            this.$root.eventHub.$emit('stu_comment_result', 'success');
          } else {
            this.$root.eventHub.$emit('stu_comment_result', 'fail');
          }
        },
        () => {
          this.$root.eventHub.$emit('stu_comment_result', 'fail');
        },
      );
    },
    //api发送礼物
    ApiSendGift(data) {
      this.apiSendGift(data).then(({ res, ok }) => {
        if (!ok) return;
        this.message({ data: res.giftResponse }, 'api');
        this.message({ data: res.danmu_message }, 'api');
      });
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventSendGift',
        data: {
          channel: 'gift_api',
          giftId: data.giftId,
          sendUniqueId: data.sendUniqueId,
        },
      });
    },
    //pk补发
    sendPKData(data) {
      this.sendPkData(data).then(({ res, ok }) => {
        if (!ok) return;
        this.message({ data: res }, 'api');
      });
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventPKSendMessage',
        data: {
          sub_type: data.sub_type,
          channel: 'api',
          unique_id: data.unique_id,
        },
      });
    },
    //显示课中排行榜
    sendRank(datas, type, taskType) {
      //
      if (utils.messageFilter(datas.unique_id, 'displayList')) {
        //
        if (taskType == 'question_ranking') {
          this.send('get_answer_rank', {
            type: 'get_answer_rank',
            unique_id: utils.createUniqueId(),
            lesson_id: this.lesson_id,
            uid: this.userID,
            rev_unique_id: datas.unique_id,
            smallClassId: this.smallClassId,
          });
          // this.$root.eventHub.$emit("ranks", datas);
        } else if (taskType == 'badge_ranking') {
          this.send('get_badge_rank', {
            type: 'get_badge_rank',
            unique_id: utils.createUniqueId(),
            lesson_id: this.lesson_id,
            uid: this.userID,
            rev_unique_id: datas.unique_id,
            smallClassId: this.smallClassId,
            batchId: datas.data.task_data.batch_id,
          });
          // this.$root.eventHub.$emit("badgeRanks", datas);
        }
        if (type === 'sei') {
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventRankTask',
            data: {
              type:
                taskType === 'question_ranking'
                  ? 'question_rank'
                  : 'badge_rank',
              source: type,
              unique_id: datas.unique_id,
            },
          });
        }
        let obj = common.getSession('rankList') || {};
        obj.canUse = false;
        common.setSession('rankList', obj);
      }
    },
    sendPk(datas, type, pkType) {
      if (utils.messageFilter(datas.unique_id, 'displayList')) {
        if (pkType === 'start') {
          //开始pk
          this.send('pk', { sub_type: 'matching' });
        } else if (pkType == 'scoring') {
          this.send('pk', { sub_type: 'get_scoring' });
        } else if (pkType == 'end') {
          this.send('pk', { sub_type: 'get_result' });
        }
        if (type === 'sei') {
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventPKTaskMessage',
            data: {
              unique_id: datas.unique_id,
              sub_type: pkType,
              source: 'sei',
            },
          });
        }
        let obj = common.getSession('pkList') || {};
        obj.canUse = false;
        common.setSession('pkList', obj);
      }
    },
    //显示or隐藏评价
    sendComment(datas, type) {
      //评价
      if (utils.messageFilter(datas.unique_id, 'displayList')) {
        //
        datas.resoure = type;
        this.$root.eventHub.$emit('comments', datas);
        let obj = common.getSession('commentList') || {};
        obj.canUse = false;
        common.setSession('commentList', obj);
      }
    },
    //礼物开关
    sendGiftSwitch(datas, type) {
      if (utils.messageFilter(datas.unique_id, 'displayList')) {
        datas.resoure = type;
        this.$root.eventHub.$emit('giftSwitch', datas);
        let obj = common.getSession('giftSwitchList') || {};
        obj.canUse = false;
        common.setSession('giftSwitchList', obj);
        if (type === 'sei') {
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventGiftSwitchTask',
            data: {
              source: type,
              unique_id: datas.unique_id,
              state: datas.data.task_data.state,
            },
          });
        }
      }
    },
    //关闭题
    closeQuestion(datas, type) {
      if (utils.messageFilter(datas.unique_id, 'displayList')) {
        //
        this.$root.eventHub.$emit('closeQuestion', datas);
        let obj = common.getSession('questionCloseList');
        if (obj) {
          obj.canUse = false;
          common.setSession('questionCloseList', obj);
        }
        let qobj = common.getSession('questionList') || {};
        if (
          qobj.canUse &&
          qobj.datas.data.quick_question_id ==
          obj.datas.data.task_data.question_id
        ) {
          qobj.canUse = false;
          common.setSession('questionList', qobj);
        }
      }
    },
    message(event, type = 'websocket') {
      let datas =
        typeof event.data == 'object' ? event.data : JSON.parse(event.data);
      if (type == 'websocket') {
        if (this.protocol_switch == 1) {
          //
          let reader = new FileReader();
          reader.readAsArrayBuffer(event.data);
          reader.onload = (e) => {
            let dataView = new DataView(reader.result, 0);
            let packetLen = dataView.getInt32(0);
            let headerLen = dataView.getInt16(4);
            let version = dataView.getInt16(6);
            let op = dataView.getInt32(8);
            let seq = dataView.getInt32(12);
            //
            switch (op) {
              case 3: //心跳返回数据，判断长连接是否通畅
                //
                clearTimeout(this.intervalData['noPingInterval']);
                break;
              case 8: //鉴权成功
                //

                // this.send("stu_rcv_pre_lesson"); //发送进课消息
                // this.checkPing();
                break;
              //   case 1001: //进课成功
              //
              //  var textDecoder = new TextDecoder("utf-8");
              //   var msgBody = textDecoder.decode(reader.result.slice(16, packetLen));
              //
              // break;
              default:
                var textDecoder = new TextDecoder('utf-8');
                var msgBody = textDecoder.decode(
                  reader.result.slice(16, packetLen),
                );
                //
                datas = JSON.parse(msgBody);

                this.commonMessage(datas, type);
            }
          };
        } else {
          this.commonMessage(datas, type);
        }
      } else {
        this.commonMessage(datas, type);
      }
    },
    commonMessage(datas, type) {
      //
      let temServerTime = common.getTemServerTime();
      if (datas == 2) {
        clearTimeout(this.intervalData['noPingInterval']);
        return;
      }

      //ack应答
      if (
        (type == 'sei' ||
          (type == 'api' &&
            datas.type &&
            datas.type == 'teacher_send_quick_question') ||
          (datas.ack && datas.ack == '1')) &&
        datas.unique_id
      ) {
        if (utils.messageFilter(datas.unique_id, 'ackList')) {
          // console.log(
          //   utils.messageFilter(datas.unique_id, 'ackList'),
          //   '-----------995',
          // );
          //
          let uuid = utils.createUniqueId();
          this.magAckIntervalData[uuid] = null;
          /*在这里伪直播把用的sei的时间戳 是不对的 需要修改*/
          let lData = JSON.stringify(datas.data || {});
          let ackData = {
            type: 'msg_ack',
            unique_id: uuid,
            data: Object.assign(JSON.parse(lData), {
              recv_unique_id: datas.unique_id,
              recv_type: datas.type,
              source: type,
              small_id: this.smallClassId,
              class_id: this.class_id,
              teacher_id: this.teacher_id,
              lesson_id: this.lesson_id,
              student_id: this.userID,
            }),
          };

          this.send('msg_ack', ackData);
        }
      }
      //链接成功
      if (datas.type === 'srv_connect_sucess') {
        clearTimeout(this.intervalData['wsReconnectInterval']);
        this.intervalData['wsReconnectInterval'] = null;
        this.send('stu_rcv_pre_lesson'); //发送进课消息
        this.wsReconnectionNum = 0;
        return;
      }
      //进课成功
      if (datas.type === 'sys_result_info') {
        window.clearTimeout(this.intervalData['noLessonInInterval']);
        this.sendPing();
        this.checkPing();
        this.upDateWsLessonInState(1);
        return;
      }
      //更新服务器时间到本地
      if (datas.data && datas.data.srv_time && type === 'websocket') {
        this.upDateServerTime(datas.data.srv_time);
        //this.$store.commit('upDateServerTime', datas.data.srv_time)
      }
      //清除ack补发计时器
      if (
        datas.type === 'msg_ack' &&
        this.magAckIntervalData[datas.unique_id]
      ) {
        clearTimeout(this.magAckIntervalData[datas.unique_id]);
        delete this.magAckIntervalData[datas.unique_id];
        return;
      }
      //合并弹幕消息
      if (
        datas.type === 'danmu_message_more' &&
        utils.messageFilter(datas.unique_id, 'msgList')
      ) {
        datas.data.forEach((item, index) => {
          this.message({ data: item }, type);
        });
        return;
      }
      // if (!datas.data) return;
      switch (datas.type) {
        case 'stu_kick': //踢人
          let deviceid = common.getSession('random_deviceid'); //获取本地设备ID
          if (datas.data.deviceid && datas.data.deviceid != deviceid) {
            this.ws_close();
            this.closeWsClearInterval();
            this.resetState();
            this.$router.replace('/login');
            this.alertIsShow = 1;
            this.$root.eventHub.$emit('createLog', {
              id: 'LMTrackEventKick',
              data: {
                unique_id: datas.unique_id,
                local_device: deviceid,
                device: datas.data.deviceid,
                reffer: type,
              },
            });
          }
          break;
        case 'teacher_send_task': //教师发言
          let task_name = datas.data.task_name;
          if (task_name === 'link_microphone_start') {
            // 连麦开始
            this.$root.eventHub.$emit('createLog', {
              id: 'LMTrackEventTelCall',
              data: {
                unique_id: datas.unique_id,
                channel: datas.data.task_data.channel_name,
                reffer: type,
              },
            });
            if (utils.messageFilter(datas.unique_id, 'msgList')) {
              this.$root.eventHub.$emit('telCall', datas.data.task_data);
            }
          } else if (task_name === 'link_microphone_end') {
            // 连麦结束
            this.$root.eventHub.$emit('createLog', {
              id: 'LMTrackEventTelOver',
              data: {
                unique_id: datas.unique_id,
                reffer: type,
              },
            });
            if (utils.messageFilter(datas.unique_id, 'msgList')) {
              this.$root.eventHub.$emit('telOver', datas);
            }
          } else if (task_name === 'jinyan') {
            let jinyan_type = datas.data.task_data.jinyan_type;
            let jytime = datas.data.task_data.jinyan_min;
            jytime = jytime > 0 ? '1' : '0';
            if (jinyan_type == 2) {
              this.upDateTextBannedSpeak(jytime);
              return;
            }
            if (jytime != this.banned_speak) {
              //
              if (jytime == 0) {
                this.$root.eventHub.$emit('createLog', {
                  id: 'LMTrackEventCancelBanned',
                  data: {
                    unique_id: datas.unique_id,
                    notify: datas.data.display == '0' ? 0 : 1,
                    reffer: type,
                  },
                });
              } else {
                this.$root.eventHub.$emit('createLog', {
                  id: 'LMTrackEventSetBanned',
                  data: {
                    unique_id: datas.unique_id,
                    notify: datas.data.display == '0' ? 0 : 1,
                    reffer: type,
                  },
                });
              }
              this.upDateBannedSpeak(jytime);
              if (datas.data.display == '0') return;
              this.$root.eventHub.$emit('teacher_banned', jytime);
            }
          } else if (task_name === 'badge') {
            //徽章
            if (utils.messageFilter(datas.unique_id, 'msgList')) {
              setTimeout(() => {
                //
                this.$root.eventHub.$emit('badge', datas);
              }, 2000);
            }
          } else if (
            task_name === 'question_ranking' ||
            task_name === 'badge_ranking'
          ) {
            //
            let unique_id = datas.unique_id;
            let rankList = common.getSession('rankList') || {};
            if (type === 'sei') {
              //
              if (!datas.data.task_data.unique_id) {
                //
                this.sendRank(rankList.datas, rankList.type, task_name);
              } else {
                //
                this.sendRank(datas, 'sei', task_name);
              }
              return;
            }
            if (type === 'api' || type === 'websocket') {
              if (utils.messageFilter(unique_id, 'msgList')) {
                this.$root.eventHub.$emit('createLog', {
                  id: 'LMTrackEventRankTask',
                  data: {
                    type:
                      task_name === 'question_ranking'
                        ? 'question_rank'
                        : 'badge_rank',
                    source: type,
                    unique_id: unique_id,
                  },
                });
                rankList = {
                  datas: datas,
                  type: type,
                  canUse: true,
                };
                common.setSession('rankList', rankList);
                clearInterval(this.intervalData['interval_rank']);
                this.intervalData['interval_rank'] = setInterval(() => {
                  let rankList = common.getSession('rankList') || {};
                  if (!rankList.canUse) {
                    clearInterval(this.intervalData['interval_rank']);
                    return;
                  }

                  if (Date.now() - this.seiTime > 4000) {
                    rankList.canUse = false;
                    this.sendRank(rankList.datas, rankList.type, task_name);
                  }
                }, 1000);
              }
            }
          } else if (task_name === 'comments') {
            let unique_id = datas.unique_id;
            let commentList = common.getSession('commentList') || {};
            if (type === 'sei') {
              //sei评价
              if (!datas.data.task_data.show) {
                //
                this.sendComment(commentList.datas, commentList.type);
              } else {
                // console.log(type, new Date(), "收评价",datas);
                this.sendComment(datas, 'sei');
              }
              return;
            }
            if (type === 'api' || type === 'websocket') {
              if (utils.messageFilter(unique_id, 'msgList')) {
                commentList = {
                  datas: datas,
                  type: type,
                  canUse: true,
                };
                common.setSession('commentList', commentList);
                clearInterval(this.intervalData['interval_comment']);
                this.intervalData['interval_comment'] = setInterval(() => {
                  let commentList = common.getSession('commentList') || {};
                  if (!commentList.canUse) {
                    clearInterval(this.intervalData['interval_comment']);
                    //
                    return;
                  }
                  if (Date.now() - this.seiTime > 4000) {
                    commentList.canUse = false;
                    //
                    this.sendComment(commentList.datas, commentList.type);
                  }
                }, 1000);
              }
            }
          } else if (task_name === 'end_question') {
            let unique_id = datas.unique_id;
            let questionCloseList =
              common.getSession('questionCloseList') || {};
            if (type === 'sei') {
              //sei评价
              if (!datas.data.task_data.close) {
                //
                this.closeQuestion(
                  questionCloseList.datas,
                  questionCloseList.type,
                );
              } else {
                this.closeQuestion(datas, 'sei');
              }
              return;
            }
            if (type === 'api' || type === 'websocket') {
              if (utils.messageFilter(unique_id, 'msgList')) {
                questionCloseList = {
                  datas: datas,
                  type: type,
                  canUse: true,
                };
                common.setSession('questionCloseList', questionCloseList);
                clearInterval(this.intervalData['interval_closeQuestion']);
                this.intervalData['interval_closeQuestion'] = setInterval(
                  () => {
                    let questionCloseList =
                      common.getSession('questionCloseList') || {};
                    if (!questionCloseList.canUse) {
                      clearInterval(
                        this.intervalData['interval_closeQuestion'],
                      );

                      return;
                    }
                    if (Date.now() - this.seiTime > 4000) {
                      questionCloseList.canUse = false;

                      this.closeQuestion(
                        questionCloseList.datas,
                        questionCloseList.type,
                      );
                    }
                  },
                  1000,
                );
              }
            }
          } else if (task_name === 'giftSwitch') {
            let unique_id = datas.unique_id;
            let giftSwitchList = common.getSession('giftSwitchList') || {};
            if (type === 'sei') {
              //sei评价
              if (!datas.data.task_data.unique_id) {
                //
                this.sendGiftSwitch(giftSwitchList.datas, giftSwitchList.type);
              } else {
                // console.log(type, new Date(), "收到礼物指令");
                this.sendGiftSwitch(datas, 'sei');
              }
              return;
            }
            if (type === 'api' || type === 'websocket') {
              if (utils.messageFilter(unique_id, 'msgList')) {
                // console.log(type, new Date(), "收到礼物指令");
                this.$root.eventHub.$emit('createLog', {
                  id: 'LMTrackEventGiftSwitchTask',
                  data: {
                    source: type,
                    unique_id: datas.unique_id,
                    state: datas.data.task_data.state,
                  },
                });
                giftSwitchList = {
                  datas: datas,
                  type: type,
                  canUse: true,
                };
                common.setSession('giftSwitchList', giftSwitchList);
                clearInterval(this.intervalData['interval_giftSwitchList']);
                this.intervalData['interval_giftSwitchList'] = setInterval(
                  () => {
                    let giftSwitchList =
                      common.getSession('giftSwitchList') || {};
                    if (!giftSwitchList.canUse) {
                      clearInterval(
                        this.intervalData['interval_giftSwitchList'],
                      );
                      return;
                    }
                    if (Date.now() - this.seiTime > 4000) {
                      // console.log(type, new Date(), "容错模式展示");
                      giftSwitchList.canUse = false;
                      this.sendGiftSwitch(
                        giftSwitchList.datas,
                        giftSwitchList.type,
                      );
                    }
                  },
                  1000,
                );
              }
            }
          }
          break;
        case 'bzr_send_task':
          let bzr_task_name = datas.data.task_name;
          if (bzr_task_name === 'jinyan') {
            let jytime = datas.data.task_data.jinyan_min;
            this.upDateBzrTextBanned({
              time: datas.data.srv_time,
              timeLength: jytime,
            });
          }
          break;
        case 'encourage_message': //鼓励
          if (utils.messageFilter(datas.unique_id, 'msgList')) {
            this.$root.eventHub.$emit('encourage', datas);
            this.$root.eventHub.$emit('createLog', {
              id: 'LMTrackEventEncourage',
              data: {
                source: type,
                unique_id: datas.unique_id,
              },
            });
          }
          break;
        case 'hand_up_show': //连麦举手
          if (utils.messageFilter(datas.unique_id, 'msgList')) {
            this.$root.eventHub.$emit('requestHandup', datas);
          }
          break;
        case 'praise_message': //全体表扬
          if (utils.messageFilter(datas.unique_id, 'msgList')) {
            clearInterval(this.intervalData[datas.data.recv_unique_id]);
            delete this.intervalData[datas.data.recv_unique_id];
            this.$root.eventHub.$emit('allPraise', { datas, type });
          }
          break;
        case 'singlepraise_message': //单人表扬
          if (utils.messageFilter(datas.unique_id, 'msgList')) {
            this.$root.eventHub.$emit('singlePraise', datas);
            this.$root.eventHub.$emit('createLog', {
              id: 'LMTrackEventSinglePraise',
              data: {
                source: type,
                unique_id: datas.unique_id,
              },
            });
          }
          break;
        case 'praise_ack': //全体表扬
          if (utils.messageFilter(datas.unique_id, 'msgList')) {
            this.send('praise_by_answer', {
              type: 'praise_by_answer',
              unique_id: utils.createUniqueId(),
              lesson_id: this.lesson_id,
              student_id: this.userID,
              smallClassId: this.smallClassId,
              request_id: datas.unique_id,
              name: this.realname,
            });
            this.$root.eventHub.$emit('createLog', {
              id: 'LMTrackEventBatchPraiseTask',
              data: {
                source: type,
                unique_id: datas.unique_id,
              },
            });
          }
          break;
        case 'teacher_send_quick_question': //老师下发快速问答
          let unique_id = datas.unique_id;
          let questionList = common.getSession('questionList') || {};
          if (type === 'sei') {
            //sei发题

            if (!datas.data.quick_question_id) {
              console.log(1404, type, new Date(), '收题');
              this.sendQusestion(questionList.datas, questionList.type);
            } else {
              console.log(1406, type, new Date(), '收题');
              this.sendQusestion(datas, 'sei');
            }
            return;
          }
          if (type === 'api' || type === 'websocket') {
            if (utils.messageFilter(unique_id, 'msgList')) {
              console.log(type, new Date(), '收题');
              this.$root.eventHub.$emit('createLog', {
                id: 'LMTrackEventReceiveQuestion',
                data: {
                  unique_id,
                  question_id: datas.data.quick_question_id,
                  reffer: type,
                },
              });
              //api,websocket发题
              questionList = {
                datas: datas,
                type: type,
                canUse: true,
              };

              common.setSession('questionList', questionList);
              clearInterval(this.intervalData['interval_question']);
              this.intervalData['interval_question'] = setInterval(() => {
                let questionList = common.getSession('questionList') || {};
                if (!questionList.canUse) {
                  clearInterval(this.intervalData['interval_question']);
                  //
                  return;
                }
                if (Date.now() - this.seiTime > 4000) {
                  questionList.canUse = false;

                  this.sendQusestion(questionList.datas, questionList.type);
                }
              }, 1000);
            }
          }
          break;
        case 'teacher_change_coin': //老师发金币
          let coinList = common.getSession('coinList') || {};
          if (type == 'api' || type == 'websocket') {
            if (utils.messageFilter(datas.unique_id, 'msgList')) {
              //老师加减金币
              //
              let coinData = {
                datas: datas,
                type: type,
                canUse: true,
              };
              coinList[datas.unique_id] = coinData;
              common.setSession('coinList', coinList);
              clearInterval(this.intervalData['interval_coin']);
              this.intervalData['interval_coin'] = setInterval(() => {
                let list = common.getSession('coinList') || {};
                if (Object.keys(list).length == 0) {
                  //
                  clearInterval(this.intervalData['interval_coin']);
                  return;
                }
                //
                if (Date.now() - this.seiTime > 4000) {
                  //
                  coinList[datas.unique_id].canUse = false;
                  for (let x in list) {
                    this.sendCoin(list[x].datas, list[x].type);
                  }
                  common.setSession('coinList', {});
                }
              }, 1000);
            }
          }
          if (type == 'sei') {
            if (!datas.data.coin) {
              //
              this.sendCoin(
                coinList[datas.unique_id].datas,
                coinList[datas.unique_id].type,
              );
            } else {
              this.sendCoin(datas, 'sei');
              //
            }
          }

          break;
        case 'danmu_message': //普通弹幕消息
          if (utils.messageFilter(datas.unique_id, 'msgList')) {
            window.clearTimeout(this.intervalData[datas.data.recv_unique_id]);
            delete this.intervalData[datas.data.recv_unique_id];
            this.danmu_start_timestamp = datas.data.srv_time;
            this.$root.eventHub.$emit('danmu', datas);
          }
          break;
        case 'teacher_close_lesson': //老师点击下课
          this.upDateLessonState(3);
          this.$root.eventHub.$emit('classOver');
          break;
        case 'sys_send_iss_cmd': //切换流地址
          if (
            datas.data.cmd_type === 'obs_switch' &&
            utils.messageFilter(datas.unique_id, 'msgList')
          ) {
            this.$root.eventHub.$emit('obsswitch', datas);
          }
          break;
        case 'sys_send_config_to_client': //接受服务端指令
          if (datas.data.action === 'ppt_page_turning') {
            //ppt翻页
            this.$root.eventHub.$emit('ppt_page_turning', datas);
          }
          break;
        case 'teacher_send_answer_rank': //答题排行数据
          if (utils.messageFilter(datas.unique_id, 'msgList')) {
            clearTimeout(this.intervalData[datas.data.recv_unique_id]);
            delete this.intervalData[datas.data.recv_unique_id];
            this.$root.eventHub.$emit('ranks', datas);
            this.$root.eventHub.$emit('createLog', {
              id: 'LMTrackEventRankData',
              data: {
                type: 'question_rank',
                source: type,
                unique_id: datas.unique_id,
              },
            });
          }
          break;
        case 'teacher_send_badge_rank': //徽章排行数据
          if (utils.messageFilter(datas.unique_id, 'msgList')) {
            clearTimeout(this.intervalData[datas.data.recv_unique_id]);
            delete this.intervalData[datas.data.recv_unique_id];
            this.$root.eventHub.$emit('badgeRanks', datas);
            this.$root.eventHub.$emit('createLog', {
              id: 'LMTrackEventRankData',
              data: {
                type: 'badge_rank',
                source: type,
                unique_id: datas.unique_id,
              },
            });
          }
          break;
        case 'sendCoinGiftResponse': //礼物发送结果
          if (utils.messageFilter(datas.unique_id, 'msgList')) {
            clearInterval(this.intervalData[datas.data.recv_unique_id]);
            delete this.intervalData[datas.data.recv_unique_id];
            this.$root.eventHub.$emit('sendGiftResult', datas.data);
            this.$root.eventHub.$emit('createLog', {
              id: 'LMTrackEventSendGiftCallBack',
              data: {
                source: type,
                code: datas.data.code,
                unique_id: datas.unique_id,
                coinTotal: datas.data.coinTotal,
              },
            });
          }
          break;
        case 'sendGoldResponse': //按选项加金币
          if (utils.messageFilter(datas.unique_id, 'displayList')) {
            let obj = common.getSession('coinList') || {};
            Reflect.deleteProperty(obj, datas.unique_id);
            common.setSession('coinList', obj);
            clearInterval(this.intervalData[datas.data.recv_unique_id]);
            delete this.intervalData[datas.data.recv_unique_id];
            this.$root.eventHub.$emit('coin', datas);
          }
          break;
        case 'pk':
          let pk_sub_type = datas.data.sub_type;
          if (type === 'api' || type === 'websocket') {
            if (utils.messageFilter(datas.unique_id, 'msgList')) {
              if (
                pk_sub_type === 'scoring' ||
                pk_sub_type === 'end' ||
                pk_sub_type === 'start'
              ) {
                //阶段积分展示命令
                let unique_id = datas.unique_id;
                let pkList = {
                  datas: datas,
                  type: type,
                  canUse: true,
                };
                common.setSession('pkList', pkList);
                this.$root.eventHub.$emit('createLog', {
                  id: 'LMTrackEventPKTaskMessage',
                  data: {
                    unique_id: unique_id,
                    sub_type: pk_sub_type,
                    source: type,
                  },
                });
                clearInterval(this.intervalData['interval_pk']);
                this.intervalData['interval_pk'] = setInterval(() => {
                  let pkList = common.getSession('pkList') || {};
                  if (!pkList.canUse) {
                    clearInterval(this.intervalData['interval_pk']);
                    return;
                  }
                  if (Date.now() - this.seiTime > 4000) {
                    // console.log(type, new Date(), "容错模式展示");
                    pkList.canUse = false;
                    this.sendPk(pkList.datas, pkList.type, pk_sub_type);
                  }
                }, 1000);
              } else {
                this.$root.eventHub.$emit('createLog', {
                  id: 'LMTrackEventPKBusinessMessage',
                  data: {
                    unique_id: datas.unique_id,
                    sub_type: pk_sub_type,
                    source: type,
                    recv_unique_id: datas.data.recv_unique_id,
                  },
                });
                if (pk_sub_type === 'matching_result') {
                  //匹配对手数据
                  this.$root.eventHub.$emit('pkMatchingResult', {
                    datas,
                    anim: true,
                  });
                } else if (pk_sub_type === 'scoring_result') {
                  //阶段积分数据
                  this.$root.eventHub.$emit('pkScoringResult', datas);
                } else if (pk_sub_type === 'result') {
                  //结果数据
                  this.$root.eventHub.$emit('pkResult', datas);
                }
              }
              clearInterval(this.intervalData[datas.data.recv_unique_id]);
              delete this.intervalData[datas.data.recv_unique_id];
            }
          } else if (type === 'sei') {
            let pkList = common.getSession('pkList') || {};
            if (!datas.data.unique_id) {
              //
              this.sendPk(pkList.datas, pkList.type, pk_sub_type);
            } else {
              //
              this.sendPk(datas, 'sei', pk_sub_type, datas);
            }
          }
          break;
        case 'switch_soe': //切换语音评测服务商指令
          if (utils.messageFilter(datas.unique_id, 'msgList')) {
            this.send('get_soe', { rev_unique_id: datas.unique_id });
            this.$root.eventHub.$emit('createLog', {
              id: 'LMTrackEventSwitchSoe',
              data: {
                unique_id: datas.unique_id,
                source: type,
              },
            });
          }
          break;
        case 'soe_result': //执行切换语音服务商
          if (utils.messageFilter(datas.unique_id, 'msgList')) {
            clearTimeout(this.intervalData[datas.data.recv_unique_id]);
            delete this.intervalData[datas.data.recv_unique_id];
            this.updateVoiceSoe(datas.data.name);
            this.$root.eventHub.$emit('createLog', {
              id: 'LMTrackEventSwitchSoeResult',
              data: {
                source: type,
                unique_id: datas.unique_id,
                soe: datas.data.name,
              },
            });
          }
          break;
        case 'stu_comment_success':
          if (utils.messageFilter(datas.unique_id, 'msgList')) {
            clearTimeout(this.intervalData[datas.data.recv_unique_id]);
            delete this.intervalData[datas.data.recv_unique_id];
            this.$root.eventHub.$emit('stu_comment_result', 'success');
          }
          break;
      }
    },
    close() {
      //长连接断开埋点
      !this.zdclose &&
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventSocketClose',
        data: {
          url: common.getSession('websocket_wss_url'),
          reason: '长连接自动断开',
        },
      });
      if (!!this.intervalData['wsReconnectInterval']) return;
      this.intervalData['wsReconnectInterval'] = setTimeout(() => {
        this.upDateWsLessonInState(0);
        this.intervalData['wsReconnectInterval'] = null;
        if (this.zdclose) {
          this.zdclose = false;
        } else {
          this.wsReconnectionNum++;
          if (this.wsReconnectionNum >= this.get_livemsg_addr_num) {
            let data = {
              class_id: this.class_id,
              lesson_id: this.lesson_id,
              wss: 1,
            };
            liSrv.getLivemsgAddr(data, (res, ok) => {
              if (!ok) return;
              common.setSession('websocket_wss_url', res.wss);
              this.wsReconnectionNum = 0;
            });
          }
          this.doWebSocket();
        }
      }, this.ping_recv_timeout * 1000);
    },
    send(type, data = {}, retryData = {}) {

      const temServerTime = common.getTemServerTime();

      if (!retryData.unique_id) {
        retryData.retry_count = 0;
        retryData.unique_id = utils.createUniqueId();
      }
      let wsData = {
        message_id: this.userID + 'srv' + temServerTime,
        unique_id: retryData.unique_id,
        type: type==='stu_answer_playback_question'?'stu_answer_quick_question':type, //题型
        data: {
          student_id: this.userID,
          teacher_id: this.teacher_id,
          class_id: this.class_id,
          lesson_id: this.lesson_id,
          srv_time: temServerTime,
          stu_cli_time: temServerTime,
          audio_time: 0,
        },
      };
      const eventData = {
        get_answer_rank: 'getAnswerRanking',
        get_badge_rank: 'getBadgeRanking',
        praise_by_answer: 'getPraiseData',
        sendCoinGift: 'ApiSendGift',
        part_coin: 'getMsgClientData',
        pk: 'sendPKData',
        stu_comment: 'commitComment',
      };
      let needTimeout = true;
      switch (type) {
        case 'stu_rcv_pre_lesson': //进课
          wsData.token = this.COOK;
          wsData.data.deviceid = utils.createDeviceId();
          wsData.data.version = common.version;
          wsData.data.device = common.device;
          wsData.data.last_rev_srv_time = temServerTime;
          wsData.data.get_last_quick_question = temServerTime;
          this.checkLessonIn();
          needTimeout = false;
          //
          break;
        case 'stu_answer_quick_question': //回答快速问答
          wsData.data = Object.assign(wsData.data, data);
          wsData.ack = '0';
          wsData.data.question_unique_id = data.recv_unique_id;
          wsData.data.stu_receive_q_time = temServerTime;
          wsData.data.small_id = this.smallClassId;
          delete wsData.data.recv_unique_id;
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventAnswer',
            data: {
              unique_id: data.recv_unique_id,
              lesson_id: this.lesson_id,
              question_id: data.quick_question_id,
              duration: data.use_time,
              answer: data.answer,
            },
          });
          break;
        case 'stu_answer_playback_question': //回答快速问答
          wsData.data = Object.assign(wsData.data, data);
          wsData.ack = '0';
          wsData.data.question_unique_id = data.recv_unique_id;
          wsData.data.stu_receive_q_time = temServerTime;
          wsData.data.small_id = this.smallClassId;
          delete wsData.data.recv_unique_id;
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventAnswer',
            data: {
              unique_id: data.recv_unique_id,
              lesson_id: this.lesson_id,
              question_id: data.quick_question_id,
              duration: data.use_time,
              answer: data.answer,
            },
          });
          break;

        case 'exp_stu_answer_quick_question': //回答快速问答-录播课
          wsData.data = Object.assign(wsData.data, data);
          wsData.ack = '0';
          wsData.data.question_unique_id = data.recv_unique_id;
          wsData.data.stu_receive_q_time = temServerTime;
          wsData.data.small_id = this.smallClassId;
          delete wsData.data.recv_unique_id;
          break;
        case 'stu_send_danmu_message': //发弹幕
          wsData.data.msg_body = data;
          needTimeout = false;
          break;
        case 'msg_ack':
          wsData = data;
          // 伪直播更换回正确的服务器时间
          if (
            this.class_type === 10 &&
            this.fakeLive &&
            this.lessonState === 2
          ) {
            wsData.data.srv_time = temServerTime;
            wsData.data.ots_time = temServerTime;
            wsData.data.source = 'api';
          }

          break;
        case 'get_answer_rank': //获取答题榜数据
          wsData = data;
          this.ws &&
          this.ws.readyState === 1 &&
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventSendRankReq',
            data: {
              type: 'question_rank',
              channel: 'socket', //"rank_api",socket
              rev_unique_id: wsData.rev_unique_id,
            },
          });
          break;
        case 'get_badge_rank': //获取徽章榜数据
          wsData = data;
          this.ws &&
          this.ws.readyState === 1 &&
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventSendRankReq',
            data: {
              type: 'badge_rank',
              channel: 'socket',
              rev_unique_id: wsData.rev_unique_id,
            },
          });
          break;
        case 'praise_by_answer': //获取表扬数据
          wsData = data;
          this.ws &&
          this.ws.readyState === 1 &&
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventBatchPraiseReq',
            data: {
              channel: 'socket',
              unique_id: data.request_id,
            },
          });
          break;
        case 'sendCoinGift': //发礼物
          wsData.data = {
            giftId: data.giftId,
            lessonId: this.lesson_id,
            sendUniqueId: data.sendUniqueId,
            smallClassId: this.smallClassId,
            uid: this.userID,
          };
          this.ws &&
          this.ws.readyState === 1 &&
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventSendGift',
            data: {
              channel: 'socket',
              giftId: data.giftId,
              sendUniqueId: data.sendUniqueId,
            },
          });
          break;
        case 'part_coin': //排行榜按选项加金币加金币
          wsData = data;
          break;
        case 'pk':
          wsData.data.sub_type = data.sub_type;
          wsData.data.small_id =
            !this.smallClassId && this.internal_users ? -2 : this.smallClassId;
          if (data.needTimeout === false) {
            //进课时取消补发
            needTimeout = false;
          }
          this.ws &&
          this.ws.readyState === 1 &&
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventPKSendMessage',
            data: {
              sub_type: data.sub_type,
              channel: 'socket',
              unique_id: wsData.unique_id,
            },
          });
          break;
        case 'get_soe':
          wsData.data.subject = this.subject;
          const soeChannel =
            this.ws && this.ws.readyState === 1 ? 'socket' : 'api';
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventSendSoe',
            data: {
              channel: soeChannel,
              rev_unique_id: data.rev_unique_id,
            },
          });
          break;
        case 'stu_comment':
          wsData.data.mark = data.mark;
          wsData.data.comment = data.comment;
          wsData.data.recv_unique_id = data.recv_unique_id;
          wsData.data.client_time = wsData.data.srv_time;
          break;
        case 'hand_up':
          needTimeout = false;
          break;
      }
      if (
        wsData.type === 'stu_answer_quick_question' &&
        this.isExperientialCourse
      ) {
        clearTimeout(this.intervalData[wsData.unique_id]);
        delete this.intervalData[wsData.unique_id];
        this.expSendSocketData(wsData);
        return;
      }
      if(type==='stu_answer_playback_question'){
        console.log('回放答题请求=====', 19999999)
        clearTimeout(this.intervalData[wsData.unique_id]);
        delete this.intervalData[wsData.unique_id];
        this.expSendSocketData(wsData);
        return;
      }
      if (this.ws && this.ws.readyState === 1) {
        if (this.protocol_switch == 1) {
          this.sendImMessage(wsData);
        } else {
          this.ws.send(JSON.stringify(wsData));
        }
        if (needTimeout) {
          let intervalKey =
            type === 'msg_ack' ? this.magAckIntervalData : this.intervalData;
          intervalKey[wsData.unique_id] = setTimeout(() => {
            if (
              this.ws &&
              this.ws.readyState === 1 &&
              retryData.retry_count < this.send_socket_times
            ) {
              this.send(type, data, retryData);
              retryData.retry_count++;
            } else {
              eventData[type]
                ? this[eventData[type]](wsData)
                : this.sendSocketData(wsData);
            }
          }, this.send_socket_data_recall * 1000);
        }
      } else {

        if (wsData.type === 'stu_rcv_pre_lesson') return;

        eventData[type]
          ? this[eventData[type]](wsData)
          : this.sendSocketData(wsData);
      }
    },
    //api补发消息
    sendSocketData(wsData) {
      liSrv.sendSocketData({ data: JSON.stringify(wsData) }, (res, ok) => {
        if (!ok) return;
        res.danmu_message && this.message({ data: res.danmu_message }, 'api');
        res.partCoin && this.message({ data: res.partCoin }, 'api');
        if (wsData.type === 'msg_ack') {
          clearTimeout(this.magAckIntervalData[res.unique_id]);
          delete this.magAckIntervalData[res.unique_id];
        }
      });
    },
    expSendSocketData(wsData) {
      liSrv.expAnswerQuestion({ data: JSON.stringify(wsData) }, (res, ok) => {
        if (!ok) return;
        res.danmu_message && this.message({ data: res.danmu_message }, 'api');
      });
    },
    checkLessonIn() {
      window.clearTimeout(this.intervalData['noLessonInInterval']);
      this.intervalData['noLessonInInterval'] = setTimeout(() => {
        //进课失败重连
        this.ws_close(true);
      }, this.ping_recv_timeout * 1000);
    },
    sendPing() {
      if (this.protocol_switch == 1) {
        this.ws && this.ws.readyState === 1 && this.heartbeat();
      } else {
        this.ws && this.ws.readyState === 1 && this.ws.send('1');
      }
      window.clearTimeout(this.intervalData['noPingInterval']);
      this.intervalData['noPingInterval'] = setTimeout(() => {
        //防止服务器不返回给客户端消息
        this.ws_close(true);
      }, this.ping_recv_timeout * 1000);
    },
    checkPing() {
      window.clearInterval(this.intervalData['checkPingInterval']);
      this.intervalData['checkPingInterval'] = window.setInterval(() => {
        this.sendPing();
      }, this.ping_time);
    },
    char2ab(str) {
      var buf = new ArrayBuffer(str.length);
      var bufView = new Uint8Array(buf);
      for (var i = 0; i < str.length; i++) {
        bufView[i] = str[i];
      }
      return buf;
    },
    //调用接口关闭长连接
    ws_close(flag) {
      this.zdclose = true;
      this.ws && this.ws.close();
      if (flag) {
        setTimeout(() => {
          this.doWebSocket();
        }, 200);
      }
    },
    //退出直播页后需要清除的定时器（点击返回，踢人）
    closeWsClearInterval() {
      let seiList = [
        'rankList',
        'commentList',
        'questionCloseList',
        'giftSwitchList',
        'questionList',
        'coinList',
        'pkList',
      ];
      seiList.forEach((list) => {
        common.removeSession(list);
      });
      for (let interval in this.intervalData) {
        clearInterval(this.intervalData[interval]);
      }
      for (let interval in this.magAckIntervalData) {
        clearInterval(this.magAckIntervalData[interval]);
      }
      this.intervalData = {};
      this.magAckIntervalData = {};
    },
    lessonInFn() {
      this.lessonIn({
        lesson_id: this.lesson_id,
        device_id: utils.createDeviceId(),
        device: common.device,
        version: common.version,
        class_id: this.class_id,
        teacher_id: this.teacher_id,
        rtcStatus: this.rtcStatus,
        subject: this.subject,
      })
        .then(({ res, ok }) => {
          if (!ok) {
            if (this.apiLessonInState !== 1) {
              this.upDateApiLessonInState(2);
            }
            return;
          }
          this.eventConfig = res.eventConfig;
          this.$root.eventHub.$emit('lessonInResult');
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventSwitchSoeResult',
            data: {
              source: 'lessonIn',
              unique_id: '',
              soe: res.soe,
            },
          });
          if (res.pkStatus == 1) {
            this.send('pk', { sub_type: 'matching', needTimeout: false });
          }
        })
        .catch(() => {
          if (this.apiLessonInState !== 1) {
            this.upDateApiLessonInState(2);
          }
        });
    },
    eventHub() {
      this.$root.eventHub.$off('exitapp');
      this.$root.eventHub.$off('open_ws');
      this.$root.eventHub.$off('close_ws');
      this.$root.eventHub.$off('danmuSend');
      this.$root.eventHub.$off('answerQuestion');
      this.$root.eventHub.$off('seiMessage');
      this.$root.eventHub.$off('apiMessage');
      this.$root.eventHub.$off('createLog');
      this.$root.eventHub.$off('toggoleProtect');
      this.$root.eventHub.$off('partCoin');
      this.$root.eventHub.$off('clearTestData');
      this.$root.eventHub.$off('lessonIn');
      this.$root.eventHub.$off('updateVersion');
      this.$root.eventHub.$off('checkMicrophonePermission');
      this.$root.eventHub.$off('playbackQuestion');
      this.$root.eventHub.$on(
        'checkMicrophonePermission',
        this.checkMicrophonePermission,
      );
      this.$root.eventHub.$on('updateVersion', (type) => {
        this.updateVersion(type);
      });
      this.$root.eventHub.$on('clearTestData', () => {
        let arr = common.get('filterList') || [];
        if (arr.length != 0) {
          let filterData = common.get('filterData') || {};
          let msgList =
            filterData[this.lesson_id] && filterData[this.lesson_id]['msgList'];
          let displayList =
            filterData[this.lesson_id] &&
            filterData[this.lesson_id]['displayList'];
          arr.forEach((item) => {
            if (msgList) {
              let index1 = msgList.findIndex((v) => {
                return v == item;
              });
              index1 != -1 && msgList.splice(index1, 1);
            }
            if (displayList) {
              let index2 = displayList.findIndex((v) => {
                return v == item;
              });
              index2 != -1 && displayList.splice(index2, 1);
            }
          });
          common.set('filterData', filterData);
          common.set('filterList', []);
        }
      });
      this.$root.eventHub.$on('partCoin', (uuid) => {
        this.send('part_coin', {
          type: 'part_coin',
          lesson_id: this.lesson_id,
          task_unique_id: uuid, // 部分加金币指令 unique_id
          student_id: this.userID,
          unique_id: utils.createUniqueId(), // 消息unique_id
        });
      });
      this.$root.eventHub.$on('exitapp', (data) => {
        this.show1 = 1;
      });
      this.$root.eventHub.$on('toggoleProtect', (data) => {
        fs
          ? utils.setNodeStorge('eyeMode', data.openEye)
          : common.set('eyeMode', data.openEye);
        // common.setSession("eyeMode", data.openEye);
        this.openEye = data.openEye;
        if (data.openEye) {
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventEyesSafeOpen',
            data: {},
          });
        } else {
          this.$root.eventHub.$emit('createLog', {
            id: 'LMTrackEventEyesSafeClose',
            data: {},
          });
        }
        this.needToast = data.needToast;
      });
      this.$root.eventHub.$on('createLog', (data) => {
        createBLog(data);
      });
      this.$root.eventHub.$on('seiMessage', (data) => {

        this.message({ data: data }, 'sei');
      });
      this.$root.eventHub.$on('apiMessage', (data) => {
        this.message({ data: data }, 'api');
      });
      //进直播页面打开长连接
      this.$root.eventHub.$on('open_ws', (rtcStatus) => {
        // 录播课开启长连接关闭轮询，直播课开启长连接和轮询，体验课不开启长连接和轮询
        if (this.class_type === 10 || !this.isExperientialCourse) {
          //开启长连接
          this.doWebSocket();
          if (this.class_type != 10) {
            //开启轮训
            this.startGetMsgClient();
          }
        }
        this.rtcStatus = rtcStatus;
        // this.lessonInFn();
        //api进课
        this.lessonInFn();
        //删除过滤池超时数据
        let temServerTime = common.getTemServerTime();
        utils.clearMessageFilterData(temServerTime);
      });
      //进课
      this.$root.eventHub.$on('lessonIn', () => {
        this.lessonInFn();
      });
      //退出直播页面关闭长连接
      this.$root.eventHub.$on('close_ws', () => {
        this.upDateApiLessonInState(0);
        this.upDateWsLessonInState(0);
        this.closeWsClearInterval();
        this.ws_close();
        // 没cook代表被踢掉
        if (common.getSession('COOK')) {
          // 录播课
          if (this.class_type === 10) {
            this.recordLessonOut({
              lessonId: this.lesson_id,
              deviceId: utils.createDeviceId(),
            });
          } else {
            this.lessonOut({
              lesson_id: this.lesson_id,
              device_id: utils.createDeviceId(),
            });
          }
        }

        if (
          common.get('filterData') &&
          common.get('filterData')[this.lesson_id]
        ) {
          let msgList = common.get('filterData')[this.lesson_id]['msgList'];
          let displayList =
            common.get('filterData')[this.lesson_id]['displayList'];
          msgList.forEach((x) => {
            if (!displayList.includes(x)) {
              utils.messageFilter(x, 'displayList');
            }
          });
        }
      });
      //发送弹幕
      this.$root.eventHub.$on('danmuSend', (data) => {
        this.send('stu_send_danmu_message', data);
      });
      //回答问题
      this.$root.eventHub.$on('answerQuestion', (data) => {
        //	quick_question_id题目id
        //	answer  题目答案
        //	type    题目类型
        //	use_time  答题时间
        //	answer_type 接收题目类型  （websocket、api、sei）
        // 录播课答题
        if (this.class_type === 10) {
          this.send('exp_stu_answer_quick_question', data);
        } else {
          this.send('stu_answer_quick_question', data);
        }
      });
      // 回放答题
      this.$root.eventHub.$on('playbackQuestion', (data) => {
        //	quick_question_id题目id
        //	answer  题目答案
        //	type    题目类型
        //	use_time  答题时间
        //	answer_type 接收题目类型  （websocket、api、sei）
        // 录播课答题
        console.log('回放答题监听=====')
        // this.send('stu_answer_quick_question', data);
        this.send('stu_answer_playback_question', data);
      });

      //送礼物
      this.$root.eventHub.$on('sendGift', (data) => {
        this.send('sendCoinGift', data);
      });
      //评价
      this.$root.eventHub.$on('stu_comment', (data) => {
        this.send('stu_comment', data);
      });
      // 连麦举手
      this.$root.eventHub.$on('hand_up', () => {
        this.showText = '举手成功';
        this.send('hand_up');
      });
    },
  },
};
</script>
<style>
@import url('./assets/css/animate.css');
#app {
  /*font-family: PingFang_Medium;平方粗体 一般用于标题
		 *font-family: PingFang_Regular;平方细体常规
		 *font-family: Roboto_Medium;数字粗体，现用于直播页倒计时
		 *font-family: Roboto_Regular;数字细体，现用于金币数量徽章数量*/
  /*font-family: "Microsoft YaHei", "微软雅黑",  PingFang_Regular, sans-serif, "黑体", SimHei;*/
  font-family: PingFang_Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  width: 100%;
  height: 100%;
  background: #e7e7e7;
  font-size: 16px;
  position: relative;
  /* min-height: 620px; */
}
.cursor {
  cursor: pointer;
}
.common_bg {
  width: 100%;
  height: 100%;
  background: url(/static/img/common/left_grass.png) left bottom no-repeat,
  url(/static/img/common/right_grass.png) no-repeat right bottom, #0089ce;
  background-size: 178px 128px;
}
.exit {
  position: absolute;
  z-index: 999;
  top: 10px;
  right: 10px;
  height: 60px;
  width: 60px;
}
.test_div {
  width: 200px;
  height: auto;
  background: rgb(99, 202, 242);
  opacity: 0.5;
  position: fixed;
  right: 0;
  top: 0;
  line-height: 30px;
  z-index: 99999;
  border-radius: 0 0 0 5px;
}
.test_div button {
  cursor: pointer;
}
.showDebugsub {
  position: fixed;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  color: #fff;
  line-height: 17px;
  text-align: center;
  font-size: 18px;
  border-radius: 50%;
  background: red;
  z-index: 999999;
}
.hide_img {
  position: absolute;
  z-index: -1;
  opacity: 0;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue